<template>
  <div class="nav">
    <el-col :span="24" style="height: 100%">
      <img src="../assets/i/logo-old.png" alt="" width="100%" />
      <el-menu
        :default-openeds="['1', '3', '4', '5']"
        style="height: 100%"
        default-active="2"
        class="el-menu-vertical-demo"
        @select="handleSelect"
        background-color="#3399ff"
        text-color="#fff"
        active-text-color="#fff"
      >
        <el-menu-item index="0">
          <span slot="title">Banner</span>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <span>业务</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="1-1">业务分类</el-menu-item>
            <el-menu-item index="1-2">业务文章</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
          <el-submenu index="1">
          <template slot="title">
            <span>案例</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="2-1">案例分类</el-menu-item>
            <el-menu-item index="2-2">案例文章</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!--<el-menu-item index="2">
          <span slot="title">案例</span>
        </el-menu-item>-->
        <el-submenu index="3">
          <template slot="title">
            <span>动态</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="3-1">公司新闻</el-menu-item>
            <el-menu-item index="3-2">政策法规</el-menu-item>
            <el-menu-item index="3-3">企业文化</el-menu-item>
            <el-menu-item index="3-4">公示公告</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <span>我们</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="4-1">公司介绍</el-menu-item>
            <el-menu-item index="4-2">荣誉资质</el-menu-item>
            <el-menu-item index="4-3">合作伙伴</el-menu-item>
            <el-menu-item index="4-4">公司客户</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="5">
          <span slot="title">招聘</span>
        </el-menu-item>
        <el-menu-item index="6">
          <span slot="title">城市</span>
        </el-menu-item>
        <el-menu-item index="7">
          <span slot="title">修改管理员密码</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navList: [
        {
          name: "Banner",
          path: "/banner",
        },
        {
          name: "业务",
          navs: [
            {
              name: "业务分类",
              path: "/bus",
            },
            {
              name: "业务文章",
              path: "/busart",
            },
          ],
        },
        {
          name: "案例",
          // path: "/caseArt",
          navs: [
            {
              name: "案例分类",
              path: "/case/category",
            },
            {
              name: "案例文章",
              path: "/caseArt",
            },
          ],
        },
        {
          name: "动态",
          navs: [
            {
              name: "公司新闻",
              path: "/dynamic/news",
            },
            {
              name: "政策法规",
              path: "/dynamic/hotspot",
            },
            {
              name: "企业文化",
              path: "/dynamic/culture",
            },
            {
              name: "公示公告",
              path: "/dynamic/notice",
            },
          ],
        },
        {
          name: "我们",
          navs: [
            {
              name: "公司介绍",
              path: "/company",
            },
            {
              name: "荣誉资质",
              path: "/we/honor",
            },
            {
              name: "合作伙伴",
              path: "/we/cooperate",
            },
            {
              name: "公司客户",
              path: "/we/customer",
            },
          ],
        },
        {
          name: "招聘",
          path: "/rec",
        },
        {
          name: "城市",
          path: "/city",
        },
        {
          name: "修改密码",
          path: "/password",
        },
      ],
    };
  },
  methods: {
    handleSelect([...data]) {

      if (data[2]) {
        this.$router.push(
          `${this.navList[data[0]]["navs"][Math.floor(data[2]) - 1]["path"]}`
        );
      } else {
        this.$router.push(`${this.navList[data[0]]["path"]}`);
      }
    },
  },
};
</script>
<style>
.el-submenu__title i {
  color: #fff;
}
.el-submenu__title {
  font-size: 16px;
}
.el-menu-item {
  font-size: 16px;
}
</style>
<style scoped lang="less">
.nav {
  width: 252px;
  height: 100vh;
  min-height: 100%;
  font-size: 20px;
}
</style>
